/* eslint-disable prefer-promise-reject-errors */
import JSZip from 'jszip';

let getExtension = fileName => fileName.split('.').pop();
let getDom = xml => new DOMParser().parseFromString(xml, 'text/xml');

export default {
    async parse(kmzFile) {
        var zip = new JSZip();
        return zip.loadAsync(kmzFile).then(zip => {
            let kmlFile = null;
            zip.forEach((relPath, file) => {
                if (getExtension(relPath) === 'kml' && kmlFile === null) {
                    kmlFile = file.async('string').then(getDom);
                }
            });
            return kmlFile;
        });
    }
};
